import Vue from 'vue';
import { DeviceType } from '@/interfaces/types';
import { Commit } from 'vuex';

interface DeviceTypeState {
	deviceTypes: {
		[id: number]: DeviceType;
	};
	selectedDeviceType: DeviceType | null;
}

export default {
	namespaced: true,
	state: {
		deviceTypes: [],
		selectedDeviceType: null,
	} as DeviceTypeState,

	getters: {
		getDeviceTypes: (state: DeviceTypeState): DeviceType[] => {
			return Object.values(state.deviceTypes);
		},

		getDeviceType:
			(state: DeviceTypeState) =>
			(id: number): DeviceType | undefined => {
				return state.deviceTypes[id];
			},

		getSelectedDeviceType: (state: DeviceTypeState): DeviceType | null => {
			return state.selectedDeviceType;
		},
	},
	mutations: {
		SET_DEVICE_TYPES(state: DeviceTypeState, deviceTypes: DeviceType[]): void {
			const ret: { [id: number]: DeviceType } = {};
			state.deviceTypes = deviceTypes.reduce((obj, deviceType) => {
				obj[deviceType.id] = deviceType;
				return obj;
			}, ret);
		},

		CHANGE_SELECTED_DEVICE_TYPE(state: DeviceTypeState, deviceTypes: DeviceType): void {
			state.selectedDeviceType = deviceTypes;
		},

		CLEAN_DEVICE_TYPES(state: DeviceTypeState): void {
			state.deviceTypes = {};
		},

		CLEAN_SELECTED_DEVICE_TYPE(state: DeviceTypeState): void {
			state.selectedDeviceType = null;
		},
	},
	actions: {
		async fetchDeviceTypes({ commit }: { commit: Commit }): Promise<void> {
			const response = await Vue.axios.get(`${process.env.VUE_APP_API_URL}/reference/devicetypes`);

			if (response && response.status === 200) {
				commit('SET_DEVICE_TYPES', response.data.data);
			}
		},

		selectDeviceType(
			{ commit }: { commit: Commit },
			{ luminaire }: { luminaire: DeviceType }
		): void {
			if (luminaire) {
				commit('CHANGE_SELECTED_DEVICE_TYPE', luminaire);
			}
		},

		cleanDeviceTypes({ commit }: { commit: Commit }): void {
			commit('CLEAN_DEVICE_TYPES');
		},

		cleanSelectedDeviceType({ commit }: { commit: Commit }): void {
			commit('CLEAN_SELECTED_DEVICE_TYPE');
		},

		cleanAllDeviceType({ commit }: { commit: Commit }): void {
			commit('CLEAN_DEVICE_TYPES');
			commit('CLEAN_SELECTED_DEVICE_TYPE');
		},
	},
};
